export default function UnreadMessagesBadge({
  count,
  size = 'md',
  className,
}: {
  count: number;
  size: 'md' | 'sm';
  className?: string;
}) {
  const badgeSize = size === 'md' ? 'w-[18px] h-[18px]' : 'w-[13px] h-[13px]';
  const textSize = size === 'md' ? 'text-xs' : 'text-[8px]';
  const plusSize = size === 'md' ? 'text-[8px]' : 'text-[6px]';

  return (
    <div
      aria-label="Unread messages badge"
      className={`${badgeSize} ${textSize} absolute bg-black text-white rounded-full border-white border flex items-center justify-center tracking-tighter ${className}`}
    >
      {count > 0 && count > 9 ? '9' : count}
      {count > 9 && <span className={`${plusSize}`}>+</span>}
    </div>
  );
}
